<template>
  <div id="Part05" :class="{ blur }">
    <div class="title">
      <img src="@/views/Part05/img/title.png" alt="logo">
    </div>
    <div class="infoImg">
      <img src="@/views/Part05/img/b01.png" alt="留言互动专区" @click="$router.push('/Interact')">
      <img src="@/views/Part05/img/b02.png" alt="同心共筑圆梦桥" @click="playVideo('gzymq')">
      <img src="@/views/Part05/img/b03.png" alt="4K超清壁纸" @click="$router.push('/DynamicPicture')">
      <img src="@/views/Part05/img/b04.png" alt="保护海豚" @click="playVideo('bhht')">
      <img src="@/views/Part05/img/b05.png" alt="大桥漫游" @click="playVideo('dqmy')">
    </div>
    <div class="Interactive">
      <img src="@/views/Part05/img/Interactive.png" alt="手机互动专区">
    </div>
    <div class="infoText">
      <div>
        <img src="@/views/Part05/img/a01.png" alt="港珠澳大桥展览馆">
        <img class="scanCode" src="@/views/Part05/img/a01-1.png" alt="港珠澳大桥展览馆二维码">
      </div>
      <div>
        <img src="@/views/Part05/img/a05.png" alt="超级工程">
        <img class="scanCode" src="@/views/Part05/img/a05-1.png" alt="超级工程二维码">
      </div>
      <div>
        <img src="@/views/Part05/img/a02.png" alt="海底沉管对接">
        <img class="scanCode" src="@/views/Part05/img/a02-1.png" alt="海底沉管对接二维码">
      </div>
      <div>
        <img src="@/views/Part05/img/a04.png" alt="带你兜风">
        <img class="scanCode" src="@/views/Part05/img/a04-1.png" alt="带你兜风二维码">
      </div>
      <div>
        <img src="@/views/Part05/img/a03.png" alt="明信片">
        <img class="scanCode" src="@/views/Part05/img/a03-1.png" alt="明信片二维码">
      </div>
      <div>
        <img src="@/views/Part05/img/a06.png" alt="敬请期待" style="cursor: auto;">
      </div>
    </div>
    <div class="thinks">
      特别鸣谢
      <span class="info">
        港珠澳大桥管理局：王彦林 唐丽娟 曾小娟 林杨
        <br>南方日报社：张由琼 徐杰
      </span>
    </div>
    <guide-button class="btn-lt" @click.native="$router.push('/TitlePage/04')">返回</guide-button>
    <guide-button class="btn-rt" @click.native="$router.push('/End')">继续</guide-button>
  </div>
</template>

<script>
export default {
  name: 'Part05',
  data () {
    return {
      blur: false,
    }
  },
  mounted () {
    this.$bgAudio.play()
  },
  beforeDestroy () {
    this.$bgAudio.pause()
  },
  methods: {
    playVideo (filename) {
      this.blur = true
      this.$bgAudio.pause()
      this.$vplayer.play({ url: filename }).then(_ => {
        this.blur = false
        this.$bgAudio.play()
      })
    },
  },
}
</script>
<style lang="scss" scoped>

#Part05 {
  position: relative;
  overflow: hidden;
  background-image: url('./img/bg.jpg');
  background-size: contain;
  .title,
  .infoImg,
  .Interactive,
  .infoText {
    text-align: center;
  }
  .title {
    margin-top: 0.4rem;
    img {
      width: 10.3rem;
    }
  }
  .infoImg {
    margin-top: 0.4rem;
    img {
      width: 14.3%;
      cursor: pointer;
    }
  }
  .Interactive {
    margin-top: 0.2rem;
    img {
      height: 0.8rem;
    }
  }
  .infoText {
    & > div {
      position: relative;
      display: inline-block;
      img {
        width: 2.285rem;
        cursor: pointer;
      }
      .scanCode {
        opacity: 0;
        position: absolute;
        bottom: 60px;
        left: 50%;
        transform: translate(-50%);
        width: 1.2rem;
        transition: all .3s ease-out;
      }

    }
    & > div:hover {
      & .scanCode {
        width: 1.5rem;
        opacity: 1;
      }
    }
  }
  .thinks {
    position: absolute;
    bottom: 0.25rem;
    left: 0.25rem;
    font-size: 0.18rem;
    color: #00a4c7;
    z-index: 102;
    cursor: pointer;
    .info {
      display: none;
    }
    &:hover {
      .info {
        display: block;
        width: 4rem;
        position: absolute;
        left: 0;
        bottom: 0.3rem;
        font-size: 0.14rem;
        text-align: left;
        line-height: 0.2rem;
        color: #ccc;
      }
    }
  }
}

</style>
